<template>
    <div v-if="displayComponent">
        <teleport to="#chart-book-navigation" v-if="isTargetAvailable">
            <span v-if="!props.chart.interactive_chart_book_id" @click="openModal" class="btn btn-xs btn-blue-ghost font-bold cursor-pointer text-sm">Save to Chart Book</span>

            <div class="inline-block" v-else>
                <label for="savedChartSelector">
                    Saved Charts
                    <select v-model="chartBookChart" @change="changeChart()" name="" class="form-control form-control-sm form-control-fixed ml-1" id="savedChartSelector">
                        <option :value="null">Select a Chart...</option>
                        <option v-for="element in chartBookCharts" :value="element">
                            {{ element.symbol_display }}
                        </option>
                    </select>
                </label>
            </div>
        </teleport>

        <modal width="28rem" v-if="showModal" @close="handleClose">
            <template #header>
                Show in Chart Books
            </template>

            <template #body>
                <label for="">
                    Name
                    <input class="form-control _form-control-sm mb-3" disabled v-model="modelTitle" type="text" />
                </label>

                <label for="chart-book">Chart Book</label>
                <select v-model="chartbookId" class="form-control" name="" id="chart-book">
                    <option v-for="element in chartBooks" :value="element.id">
                        {{ element.name }}
                    </option>
                    <option value="new">
                        + Create Chart Book
                    </option>
                </select>

                <template v-if="isJim()">
                    <div class="mt-2">
                        <label for="public-checkbox">Make Public</label>
                        <input v-model="publicFlag" id="public-checkbox" type="checkbox">
                    </div>
                </template>

                <template v-if="chartbookId === 'new'">
                    <div class="mt-2">
                        <label for="book-name">
                            New Chart Book Name
                            <input class="form-control _form-control-sm" id="book-name" type="text" v-model="chartBookName" />
                        </label>
                    </div>
                </template>

                <div class="text-sm mt-4 mb-2">
                    <a :href="getChartBookLink()">Go To My Chart Books</a>
                </div>

                <div v-if="error" class="error">
                    {{ error }}
                </div>

            </template>

            <template #footer>
                <div class="flex justify-center">
                    <div class="btn btn-sm btn-yellow-ghost inline-flex mx-1" @click="handleClose">Cancel</div>
                    <div class="btn btn-sm btn-yellow inline-flex mx-1" @click="handleUpdate">Update</div>
                </div>
            </template>
        </modal>
    </div>
</template>

<script setup>
import { ref, computed, watchEffect, onMounted, inject, nextTick } from 'vue';
import { useIsJim } from '../../mixins/IsJim';

const props = defineProps({
    title: {
        type: String,
        required: true
    },
    chartBooks: {
        type: Array,
        required: true
    },
    chart: {
        type: Object,
        required: true
    },
});

const emit = defineEmits(['update']);

const { isJim } = useIsJim();
const eventBus = inject('eventBus');

const showModal = ref(false);
const toggled = ref(props.chart.interactive_chart_book_id ? true : false);
const chartbookId = ref(props.chart.interactive_chart_book_id || props.chartBooks[0].id || 'new');
const chartBookName = ref('');
const modelTitle = ref(props.title);
const chartBookChart = ref(null);
const publicFlag = ref(false);
const error = ref(false);

const isTargetAvailable = ref(false);

watchEffect(() => {
    nextTick(() => {
        if (document.querySelector('#chart-book-navigation')) {
            isTargetAvailable.value = true;
        }
    });
});

const chartBookCharts = computed(() => {
    const pChartBook = props.chartBooks.find(c => c.id === props.chart.interactive_chart_book_id) || {};
    return pChartBook.charts || [];
});

const displayComponent = computed(() => {
    return props.chart.period === 'daily' && props.chart.spec === 'contract';
});

const resetToggle = () => {
    toggled.value = props.chart.interactive_chart_book_id ? true : false;
};

function handleClose() {
    showModal.value = false;
    resetToggle();
}

function getChartBookLink() {
    return window.route('my-folder.chart-book.index');
}

function createChartBook() {
    const route = window.route('my-folder.chart-book.store');
    return axios.post(route, {name: chartBookName.value})
        .then((response) => {
            return response.data;
        });
}

function handleEmit() {
    const pChart = {
        chartbookId: chartbookId.value,
        symbol_display: props.title
    };

    if (isJim() && publicFlag.value) {
        pChart.public = true;
    }

    emit('update', pChart);

    toggled.value = chartbookId.value ? true : false;
}

function changeChart() {
    if (!chartBookChart.value) return;
    const route = window.route('interactive-charts.home', {symbol: chartBookChart.value.symbol});
    window.location = route;
}

function handleUpdate() {
    if (chartbookId.value === 'new') {
        if (chartBookName.value === '') {
            error.value = 'Please enter a Chart Book name';
            return;
        }

        createChartBook()
            .then((newChartBook) => {
                chartbookId.value = newChartBook.id;
                props.chartBooks.push(newChartBook);
                handleEmit();
            })
    } else {
        const chartBook = props.chartBooks.find(c => c.id === chartbookId.value);
        chartBook.charts.push(props.chart);
        handleEmit();
    }

    handleClose();
}

function openModal() {
    showModal.value = true;
}
</script>
